import { z } from "zod";

/** Para her zaman en küçük birimde tam sayı + ISO 4217 kod (şema kuralı: *_minor bigint + currency). */
export const Currency = z
  .string()
  .length(3)
  .regex(/^[A-Z]{3}$/);
export type Currency = z.infer<typeof Currency>;

export const Money = z.object({
  amountMinor: z.bigint(),
  currency: Currency,
});
export type Money = z.infer<typeof Money>;
